<template>
  <button 
    :type="type" 
    :class="buttonClasses"
    class="mx-1"
    @click="emit('click', $event)"
    :disabled="disabled"
  >
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex align-items-center mb-1">
        <!-- Volitelná ikona -->
        <i
          v-if="icon"
          :class="[icon, 'me-2']"
        ></i>
        <span class="fw-bold">{{ mainText }}</span>
      </div>
      <small :class="secondaryTextClasses">{{ secondaryText }}</small>
    </div>
  </button>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'

// Props
const props = defineProps({
  mainText: {
    type: String,
    default: 'Uložit PDF'
  },
  secondaryText: {
    type: String,
    default: 'verze S - minimalistická'
  },
  icon: {
    type: String,
    default: null
  },
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => [
      'primary', 'secondary', 'success', 'danger', 'warning',
      'info', 'light', 'dark', 'outline-primary', 'outline-secondary',
      'outline-success', 'outline-danger', 'outline-warning',
      'outline-info', 'outline-light', 'outline-dark'
    ].includes(value)
  },
  size: {
    type: String,
    default: 'lg',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  },
  type: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'submit', 'reset'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['click'])

// Computed properties
const buttonClasses = computed(() => {
  const classes = ['btn', `btn-${props.variant}`]

  if (props.size === 'lg') {
    classes.push('btn-lg')
  } else if (props.size === 'sm') {
    classes.push('btn-sm')
  }

  return classes
})

const secondaryTextClasses = computed(() => {
  const classes = []

  // Určení barvy textu podle varianty tlačítka
  if (props.variant.includes('outline')) {
    classes.push('text-muted')
  } else if (['light', 'warning'].includes(props.variant)) {
    classes.push('text-dark', 'opacity-75')
  } else {
    classes.push('text-light', 'opacity-75')
  }

  return classes
})
</script>

<style scoped>
/* Dodatečné styly pro lepší vzhled */
.btn i {
  transition: transform 0.2s ease;
}

.btn:hover i {
  transform: scale(1.1);
}

.btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn:disabled:hover i {
  transform: none;
}
</style>